/**
 * Created by kubla on 01/05/17.
 */
import Constants from '../js/constants'

export function rotateArray (array, key) {
  let num = _.indexOf(array, key);
  if (num === -1) {
    return array;
  }
  return _.concat(_.slice(array, num + 1), _.slice(array, 0, num + 1));
}

export function sortKeysBy (obj, comparator) {
  var keys = _.sortBy(_.keys(obj), function (key) {
    return comparator ? comparator(obj[key], key) : key;
  });
  return _.fromPairs(_.map(keys, key => [key, obj[key]]));
}


export function orderKeysBy (obj, comparator, asc) {
  var keys = _.orderBy(_.keys(obj), comparator, asc);
  return _.fromPairs(_.map(keys, key => [key, obj[key]]));
}

export function deconstructJWT(token) {
  var segments = token.split(".");
  if (!segments instanceof Array || segments.length !== 3) {
    throw new Error("Invalid JWT");
  }
  var claims = segments[1];
  return JSON.parse(decodeURIComponent(escape(window.atob(claims))));
}
